'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Svg = function Svg(_ref) {
    var _ref$isInlined = _ref.isInlined,
        isInlined = _ref$isInlined === undefined ? false : _ref$isInlined,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        size = _ref.size,
        iconName = _ref.iconName;

    var summaryClassName = ['ui-icon', size && 'ui-icon_size' + size, className].filter(function (c) {
        return c;
    }).join(' ');
    return _react2.default.createElement(
        'svg',
        { className: summaryClassName },
        _react2.default.createElement('use', { xlinkHref: (isInlined ? '' : 'img/icons.svg') + '#icon-' + iconName })
    );
};

Svg.propTypes = {
    isInlined: _propTypes2.default.bool,
    iconName: _propTypes2.default.string.isRequired,
    size: _propTypes2.default.string,
    className: _propTypes2.default.string
};

exports.default = Svg;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-svg-icon/lib/index.js
// module id = 117
// module chunks = 0